import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getAreasModel, getStationModel, saveActorsResults } from "../../services/api";
import { toast } from "react-toastify";
import * as roomRTC from "../../services/roomRTC";

import Label from '../Labels/Label';

import "./Room.css";

const ProgressNotes = ({ isRoomHost, roomId, usuarioId, identity, participants, dataNotes, stateDataNotes }) => {
    const [titleButtonSendNotes, setTitleButtonSendNotes] = useState("Não há resultados para serem enviados");
    const [styleButtonSendNotes, setStyleButtonSendNotes] = useState("btn_group_send_notes");
    const [isSending, setIsSending] = useState(false);
    const [areaCard, setAreaCard] = useState([]);
    const [stations, setStations] = useState([]);

    const noteSum = dataNotes.reduce((sum, data) => sum + data.note, 0);
    const notaTotal = !isNaN(noteSum) ? noteSum : 0;

    const backgroundColorBorderProgress = () => {
        if (notaTotal > 10 && notaTotal < 60) {
            return "12px solid #FFCCBC";
        } else if (notaTotal >= 60) {
            return "12px solid #C8E6C9";
        } else {
            return "white";
        }
    };

    const styleProgress = () => {
        const progressSum = dataNotes.reduce((sum, data) => sum + data.progress, 0);
        const progressWidth = !isNaN(progressSum) ? progressSum : 0;

        return {
            width: `${progressWidth}px`,
            borderRight: backgroundColorBorderProgress(),
        }
    };

    const notify = (message) => {
        toast(message);
    };

    const hanlderSendDataNotes = async () => {
        if (isSending) {
            notify("Esta avaliação já foi enviada.");
            return;
        };

        setIsSending(true);

        if (stateDataNotes && Array.isArray(stateDataNotes) && stateDataNotes.length > 0) {
            let note = 0;
            let areaId;
            let estacaoId;

            let areaDescricao;
            let estacaoDescricao;

            const uniqueStations = stations.filter((station, index, self) => index === self.findIndex((u) => u._id === station._id));

            const uniqueArea = areaCard.filter((area, index, self) => index === self.findIndex((a) => a._id === area._id));

            const uniqueParticipant = participants.filter((model, index, self) => index === self.findIndex((a) => a.identity === model.identity));

            const participant = uniqueParticipant.find((p) => p.usuarioId !== usuarioId && p.identity !== identity);

            stateDataNotes.forEach(data => {
                if (data) {
                    roomRTC.sendNoteDataChannel(data.id, data.perguntaRealizada, data.note, data.noteType, roomId);

                    const station = uniqueStations.find((s) => s.id === data.cardId);

                    const area = uniqueArea.find((a) => a.id === station.areaId);

                    note = note + data.note;

                    areaId = area.id;
                    areaDescricao = area.descricao;

                    estacaoId = station.id;
                    estacaoDescricao = station.descricao;
                }
            });

            if (areaId && estacaoId && identity && participant && participant.usuarioId && participant.identity) {
                await saveActorsResults(participant.usuarioId, participant.identity, identity, areaDescricao, estacaoDescricao, note, areaId, estacaoId);
                notify("A avaliação foi concluída e os resultados do ator foram salvos.");
            } else {
                notify("Ops! Por favor, tente novamente");
            }
        }
    };

    const runningOfAreasModel = async () => {
        await getAreasModel(setAreaCard);
    };

    const runningOfStationsModel = async () => {
        await getStationModel(setStations);
    };

    useEffect(() => {
        runningOfAreasModel();

        runningOfStationsModel();

        if (stateDataNotes.length > 0) {
            setTitleButtonSendNotes("Resultados disponíveis para envio");
            setStyleButtonSendNotes("btn_group_send_notes send");
        } else {
            setTitleButtonSendNotes("Não há resultados disponíveis para envio");
            setStyleButtonSendNotes("btn_group_send_notes");
        }
    }, [stateDataNotes.length]);

    return (
        <div className='row'>
            <Label text="RESULTADOS ALCANÇADOS" />

            <div className='col-md-12 mb-2'>
                <div className='note_result_container' id='note_result_container'>
                    <div className='note_result_progress' style={styleProgress()}>
                        <b className='note_result_progress_paragraph'>{`${notaTotal}%`}</b>
                    </div>
                </div>
            </div>

            {
                isRoomHost && (
                    <div className='col-md-12 mb-2'>
                        <div className={`${styleButtonSendNotes}`} onClick={hanlderSendDataNotes}>
                            <span className="material-symbols-outlined icon_btn_notes">task_alt</span>
                            <span>{titleButtonSendNotes}</span>
                        </div>
                    </div>)
            }
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ProgressNotes);
